import React from 'react';
import Dashboard from './Dashboard';
import { logoutUser } from '../../actions/security';
import { connect } from 'react-redux';
import {
    fetchUnreadNormalNotifications,
    fetchUserData,
} from '../../actions/routines';

class DashboardContainer extends React.Component {
    componentDidMount() {
        this.props.fetchUnreadNormalNotifications();
        // The dashboard renders without the Header, which is what loads the
        // user on every other protected route. Without this the page has no
        // username and no section buttons on a cold load or a refresh, and
        // App cannot tell whether to hide the non-fair routes.
        this.props.fetchUserData();
    }

    render() {
        const { logout, userDetails, notifications, locale, isCampaignActive } =
            this.props;

        return (
            <Dashboard
                logout={logout}
                userDetails={userDetails}
                notifications={notifications}
                locale={locale}
                isCampaignActive={isCampaignActive}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails.data,
        notifications: state.unreadNormalNotifications.data,
        isCampaignActive: state.campaigns.isCampaignActive,
        locale: state.locale.lang,
    };
};

export default connect(mapStateToProps, {
    logout: logoutUser,
    fetchUnreadNormalNotifications,
    fetchUserData,
})(DashboardContainer);
